exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 600px) {\n.list__tile__title {\n        font-size: 10px;\n}\n}\n.stats-icon {\n    font-size: 3rem;\n    width: 33%;\n    display: inline-block;\n    text-align: center;\n}\n.stats-text {\n    width: 65%;\n    display: inline-block;\n}\n.stats-figure{\n    -webkit-text-decoration: bold;\n            text-decoration: bold;\n    font-size: 1.5rem;\n}\n.stats-descriptor{\n}\n", ""]);

// exports
